/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  FILTER_ORDERS_URL,
  ORDERS_PRINT_LABEL_URL,
  ORDERS_URL,
  ORDER_STATUS,
  CLIENT_ORDERS_EXPORT_URL
} from "../constants/url.constant";

import { API } from "../api";
import { setError } from "./Indicator";

export const REQUEST_CLIENT_SHIPING_LIST = "REQUEST_CLIENT_SHIPING_LIST";
export const SET_CLIENT_SHIPING_LIST = "SET_CLIENT_SHIPING_LIST";
export const REQUEST_SHIPMENT_ORDER_DETAIL = "REQUEST_SHIPMENT_ORDER_DETAIL";
export const SET_SHIPMENT_ORDER_DETAIL = "SET_SHIPMENT_ORDER_DETAIL";
export const ADD_CLIENT_SHIPING_ORDER = "ADD_CLIENT_SHIPING_ORDER";
export const UPDATE_CLIENT_SHIPING_ORDER = "UPDATE_CLIENT_SHIPING_ORDER";
export const BULK_UPLOAD_SHIPMENT_ORDER = "BULK_UPLOAD_SHIPMENT_ORDER";
export const CANCEL_CLIENT_SHIPING_ORDER = "CANCEL_CLIENT_SHIPING_ORDER";
export const RESET = "RESET";

export const resetToInitialState = () => ({
  type: RESET
});

export const getOrderStatus = (params) => {
  return async (dispatch) => {
    try {
      const res = await API.get(ORDER_STATUS, { params });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const setShipmentOrderDetail = (data) => ({
  type: SET_SHIPMENT_ORDER_DETAIL,
  payload: data
});

export const getShipmentOrderDetail = (orderId) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_ORDER_DETAIL });
    try {
      const res = await API.get(ORDERS_URL + "/" + orderId);
      dispatch(setShipmentOrderDetail(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const getAmazonOrderDetail = (orderId) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_ORDER_DETAIL });
    try {
      const res = await API.get(ORDERS_URL + "/amazon/" + orderId);
      dispatch(setShipmentOrderDetail(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const addClientShipingOrder = (shipingOrder) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CLIENT_SHIPING_ORDER });
    try {
      const res = await API.post(ORDERS_URL, shipingOrder);
      dispatch(setShipmentOrderDetail(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const updateClientShipingOrder = (orderId, shipingOrder) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CLIENT_SHIPING_ORDER });
    try {
      const res = await API.put(ORDERS_URL + "/" + orderId, shipingOrder);
      dispatch(setShipmentOrderDetail(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const addInboundWeight = (data) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + "/inbound/weight", data);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const bulkUploadInboundWeight = (AWBNo, items) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + `/${AWBNo}/inbound/weight/bulk`, { records: items });
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const deleteInboundWeight = (orderId, record) => {
  return async (dispatch) => {
    const recordId = record?.id ?? record?.pieceId ?? record?.forecastedPieceId ?? record?.inboundId ?? record?.weightId;
    const url = recordId
      ? `${ORDERS_URL}/${orderId}/inbound/weight/${recordId}`
      : `${ORDERS_URL}/${orderId}/inbound/weight`;

    try {
      return await API.delete(url, recordId ? undefined : { data: record });
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const reCalculateInbound = (AWBNo) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + `/${AWBNo}/inbound/re-calculate`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const updateInboundEOPages = (orderId, additionalEOPages) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + `/${orderId}/inbound/eo-pages`, {
        additionalEOPages,
      });
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const inboundRegenerateInvoice = (orderId) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + `/${orderId}/inbound/invoice-regenerate`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const inboundNotify = (orderId) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + `/${orderId}/inbound/notify`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const getFiles = (AWBNo) => {
  return async (dispatch) => {
    try {
      return await API.get(ORDERS_URL + `/${AWBNo}/files`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const cancelClientShipingOrder = (awb, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(ORDERS_URL + "/" + awb + "/cancel", data);
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const uploadOrderFile = (orderId, data) => {
  return async (dispatch) => {
    try {
      return await API.post(ORDERS_URL + "/" + orderId + "/file", data);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const deleteOrderFile = (orderId, fileId) => {
  return async (dispatch) => {
    try {
      return await API.delete(`${ORDERS_URL}/${orderId}/file/${fileId}`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const changeOrderTPL = (AWBNo, tplId) => {
  return async (dispatch) => {
    try {
      const res = await API.put(ORDERS_URL + "/" + AWBNo + "/change-tpl", {
        tplId
      });
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const pushOrderToWMS = (AWBNo) => {
  return async (dispatch) => {
    try {
      return await API.put(ORDERS_URL + `/${AWBNo}/push-to-wms`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const bulkUploadShipmentOrder = (fileData) => {
  return async (dispatch) => {
    dispatch({ type: BULK_UPLOAD_SHIPMENT_ORDER });
    try {
      return await API.post(`${ORDERS_URL}/bulk`, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const setClientShipingList = (data) => {
  return {
    type: SET_CLIENT_SHIPING_LIST,
    payload: data
  };
};

export const clientShipingList = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_CLIENT_SHIPING_LIST });
    try {
      const res = await API.post(FILTER_ORDERS_URL, filter);
      dispatch(setClientShipingList(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      // throw error;
    }
  };
};

/**
 * Export excel for given filter
 * @param {*} filter
 */
export const excelExport = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENT_ORDERS_EXPORT_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      console.error(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Print Label for given filter
 * @param {*} filter
 */
export const printLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ORDERS_PRINT_LABEL_URL, filter);
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Fetch Delivery proof photo/image link
 * @param {*} AWBNo
 * @returns
 */
export const getDeliveryProofLink = (AWBNo) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${ORDERS_URL}/${AWBNo}/pod-proof`);
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  rows: [],
  totalRows: 0,
  order: null
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET:
      return initialState;
    case REQUEST_CLIENT_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_CLIENT_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    case REQUEST_SHIPMENT_ORDER_DETAIL:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_SHIPMENT_ORDER_DETAIL:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        order: payload.data
      };
    case ADD_CLIENT_SHIPING_ORDER:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case UPDATE_CLIENT_SHIPING_ORDER:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case BULK_UPLOAD_SHIPMENT_ORDER:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case CANCEL_CLIENT_SHIPING_ORDER:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    default:
      return state;
  }
}
